// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__OAccK","logo":"style_logo__1Jvdd","title":"style_title__RrBFR"};